const callIfFunction = (componentOrFn, props = {}) => typeof componentOrFn === 'function' ? componentOrFn(props) : componentOrFn;

export { callIfFunction };
